import React from 'react';

import intersperse from 'intersperse';
import trimSpaceAndNewline from './trimSpaceAndNewline';

const Text = (text) =>
intersperse(trimSpaceAndNewline(text).split('\n'), <br />);

export default Text;
